import React, { useEffect, useState } from "react";
import { cutoutAsset, spriteCenter } from "./gameUtils";

// One live animal on stage: feet planted at its spot, idle-bobbing, squashing
// with a name bubble when tapped, and hopping for attention when the child
// needs a hint. Ported from StageAnimalView in AnimalFarmGameView.swift.

const StageAnimal = ({
  member,
  spot,
  content,
  reactionTick,
  wantsAttention,
  reduceMotion,
  onTap,
}) => {
  const [hopping, setHopping] = useState(false);
  const { animal } = member;
  const spriteHeight = content.height * spot.scale;
  const center = spriteCenter(spot, content);

  useEffect(() => {
    if (!wantsAttention || reduceMotion) return undefined;
    setHopping(true);
    const timer = window.setTimeout(() => setHopping(false), 1500);
    return () => window.clearTimeout(timer);
  }, [wantsAttention, reduceMotion]);

  const idleDuration = 0.9 + (animal.name.length % 4) * 0.12;
  const idleDelay = (spot.x % 7) * 0.09;

  return (
    <button
      type="button"
      className="asf-stage-animal"
      onClick={onTap}
      aria-label={`${animal.name}. Tap to hear its voice.`}
      style={{
        left: `${center.x}px`,
        top: `${center.y}px`,
        width: `${spriteHeight * 0.95}px`,
        height: `${spriteHeight * 1.05}px`,
      }}
    >
      <span
        className="asf-animal-shadow"
        aria-hidden="true"
        style={{
          width: `${spriteHeight * 0.66}px`,
          height: `${spriteHeight * 0.11}px`,
          transform: `translate(-50%, -50%) translateY(${spriteHeight * 0.48}px)`,
        }}
      />

      <span
        className={`asf-animal-idle${reduceMotion ? " no-motion" : ""}`}
        style={{ "--idle-dur": `${idleDuration}s`, "--idle-delay": `${idleDelay}s` }}
      >
        <span className={`asf-animal-hop${hopping ? " is-hopping" : ""}`}>
          <span
            key={reactionTick}
            className={reactionTick > 0 ? "asf-animal-squash" : ""}
          >
            <img
              className="asf-animal-sprite"
              src={cutoutAsset(animal.id)}
              alt=""
              draggable="false"
              style={{ height: `${spriteHeight}px` }}
            />
          </span>
        </span>
      </span>

      {reactionTick > 0 && (
        <span
          key={`bubble-${reactionTick}`}
          className="asf-name-bubble"
          aria-hidden="true"
          style={{ transform: `translate(-50%, calc(-50% - ${spriteHeight * 0.66}px))` }}
        >
          {animal.name}!
        </span>
      )}
    </button>
  );
};

export default StageAnimal;
